import React, { useState } from 'react';
import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import BookingModal from '../components/BookingModal';

export default function Home() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const services = [
    {
      icon: (
        <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      title: 'Kshar Sutra Therapy',
      description: 'Traditional Ayurvedic parasurgical treatment for anorectal disorders like piles, fistula, and fissure. Safe, non-surgical approach with lasting relief.',
      link: '/services#kshar-sutra'
    },
    {
      icon: (
        <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      title: 'Neurotherapy & Nadi Parikshan',
      description: 'Drug-free therapy targeting the nervous system through Vedic principles and pulse diagnosis. Provides relief for neurological and muscular conditions.',
      link: '/services#neurotherapy'
    },
    {
      icon: (
        <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      ),
      title: 'Panchakarma Detox',
      description: 'Comprehensive Ayurvedic cleanse and rejuvenation program. Eliminates toxins, restores balance, and enhances overall vitality through personalized therapies.',
      link: '/services#panchakarma'
    },
    {
      icon: (
        <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      ),
      title: 'Herbal Consultation & Medicines',
      description: 'Personalized Ayurvedic consultations with customized herbal remedies. 100% natural formulations to support your body\'s healing processes.',
      link: '/services#herbal'
    }
  ];

  return (
    <div>
      <Hero />

      {/* Services Section */}
      <section className="section-container bg-white">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-ayurveda-green-dark mb-4">
            Our Ayurvedic Services
          </h2>
          <div className="mx-auto h-1 w-24 bg-ayurveda-gold rounded mb-4"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Holistic healing treatments rooted in ancient Ayurvedic wisdom, 
            customized to restore your natural balance and vitality.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="section-container bg-ayurveda-green-light">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-ayurveda-green-dark mb-4">
            Why Choose Kalyan Ayurveda?
          </h2>
          <div className="mx-auto h-1 w-24 bg-ayurveda-gold rounded"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <svg className="w-10 h-10 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-ayurveda-green-dark mb-2">Ancient Wisdom</h3>
            <p className="text-gray-600">
              Time-tested Ayurvedic principles practiced for thousands of years, 
              bringing holistic healing to body, mind, and spirit.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <svg className="w-10 h-10 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-ayurveda-green-dark mb-2">Expert Practitioners</h3>
            <p className="text-gray-600">
              Experienced Ayurvedic doctors and therapists dedicated to providing 
              personalized care for your unique health needs.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <svg className="w-10 h-10 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-ayurveda-green-dark mb-2">Natural Healing</h3>
            <p className="text-gray-600">
              100% natural herbal treatments with no harsh chemicals, 
              working in harmony with your body's innate healing abilities.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-container bg-gradient-to-r from-ayurveda-green-dark to-ayurveda-green text-white">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold mb-4">
            Ready to Begin Your Healing Journey?
          </h2>
          <p className="text-lg mb-8 text-gray-100">
            Take the first step towards natural wellness. Book your consultation today 
            and experience the transformative power of Ayurveda.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => setIsBookingModalOpen(true)}
              className="bg-white text-ayurveda-green-dark hover:bg-gray-100 font-semibold py-3 px-8 rounded-lg transition shadow-lg"
            >
              Book Appointment
            </button>
            <a 
              href="https://wa.me/919992009696" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-8 rounded-lg transition shadow-lg flex items-center justify-center gap-2"
            >
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      {/* Contact Info Banner */}
      <section className="bg-ayurveda-brown-light py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div className="flex items-center justify-center gap-3">
              <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <div className="text-left">
                <p className="font-semibold text-ayurveda-green-dark">Visit Us</p>
                <p className="text-sm text-gray-600">Ghikada Rd, Charkhi Dadri</p>
              </div>
            </div>

            <div className="flex items-center justify-center gap-3">
              <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <div className="text-left">
                <p className="font-semibold text-ayurveda-green-dark">Call Us</p>
                <a href="tel:+919992009696" className="text-sm text-gray-600 hover:text-ayurveda-green">
                  099920 09696
                </a>
              </div>
            </div>

            <div className="flex items-center justify-center gap-3">
              <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div className="text-left">
                <p className="font-semibold text-ayurveda-green-dark">Hours</p>
                <p className="text-sm text-gray-600">Mon - Sat: 9 AM - 8 PM</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      <BookingModal 
        isOpen={isBookingModalOpen} 
        onClose={() => setIsBookingModalOpen(false)} 
      />
    </div>
  );
}
